module.exports = __webpack_public_path__ + "img/c_photo_3@2x.6a1ae647.png";